import { useI18n } from 'vue-i18n';

export const usePaginationDefaults = defineStore('paginationDefaults', () => {
  const { t } = useI18n();
  const paginationId = t('Pagination.Id.Generic');
  const pageQueryKey = t('Pagination.Query.Page');
  const pageSizeQueryKey = t('Pagination.Query.PageSize');
  const itemType = t('Pagination.Aria.ListItemType.Generic');
  const itemTypePlural = t('Pagination.Aria.ListItemTypePlural.Generic');
  const defaultPageSize = 8;

  return {
    paginationId,
    pageQueryKey,
    pageSizeQueryKey,
    itemType,
    itemTypePlural,
    defaultPageSize
  };
});
